import React, { useState, useEffect } from 'react';
import Modal from '~/components/modal';
import { Button, IconButton } from '~/components/button';
import usePartners from '~/view-data/use-partners';
import { formats } from '~/helper';
import { MdDelete } from 'react-icons/md';


const ModalIpList = ({ open, onClose, onSave, initialIps = [], contractId, contractData }) => {
  const [ips, setIps] = useState(initialIps);

  useEffect(() => {
    setIps(initialIps);
  }, [initialIps]);
  const [input, setInput] = useState('');
  const [ticket, setTicket] = useState('');
  const [observacao, setObservacao] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAddIp = (e) => {
    if (e) e.preventDefault();
    // Regex para IPv4 e IPv4 com máscara
    const ipv4 = /^\d{1,3}(\.\d{1,3}){3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;
    // Regex para IPv6 e IPv6 com máscara
    const ipv6 = /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$|^([\da-fA-F]{1,4}:){1,7}:(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$|^([\da-fA-F]{1,4}:){1,6}:[\da-fA-F]{1,4}(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/;
    // Regex simples para URL de DDNS (host.dominio)
    const ddns = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    // Permitir múltiplos IPs/DDNS separados por vírgula, espaço ou quebra de linha
    const entries = input
      .split(/[\s,]+/)
      .map(s => s.trim())
      .filter(Boolean);

    if (entries.length === 0) {
      setError('Digite ao menos um IP, IPv6 ou DDNS válido');
      return;
    }

    let added = 0;
    let already = 0;
    let invalid = [];
    let newIps = [...ips];

    entries.forEach(entry => {
      if (!(ipv4.test(entry) || ipv6.test(entry) || ddns.test(entry))) {
        invalid.push(entry);
        return;
      }
      if (newIps.includes(entry)) {
        already++;
        return;
      }
      newIps.push(entry);
      added++;
    });

    setIps(newIps);
    setInput('');
    if (invalid.length > 0) {
      setError(`Endereço(s) inválido(s): ${invalid.join(', ')}`);
    } else if (already > 0 && added === 0) {
      setError('Todos já foram adicionados');
    } else {
      setError('');
    }
  };

  const handleRemoveIp = (ip) => {
    setIps(ips.filter(i => i !== ip));
  };

  const { actions: { updateIpList } } = usePartners();

  const handleSave = async () => {
    if (!ticket.trim()) {
      setError('O número do Ticket é obrigatório');
      return;
    }
    setLoading(true);
    try {
      if (contractId) {
        await updateIpList({ contractId, ipList: ips, ticket, observacao });
      }
      if (onSave) onSave(ips);
      onClose();
    } catch (e) {
      setError('Erro ao salvar IPs');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} title="Cadastro de IP/DDNS do Contrato" hide={onClose} actions={[]} width="900px" height="auto">
      <div style={{ maxWidth: 860, margin: '0', padding: 0 }}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 32, alignItems: 'flex-start', width: '100%' }}>
          <div style={{ flex: '0 0 340px', minWidth: 260, maxWidth: 380, marginLeft: 0 }}>
            {/* Alinhado à esquerda, logo abaixo do título */}
            <h3 style={{ marginTop: 0 }}>Dados do Contrato</h3>
            {contractData && (
              <>
                <p><strong>ID:</strong> {contractData.id}</p>
                <p><strong>Grupo:</strong> {contractData.groupName}</p>
                <p><strong>Início:</strong> {formats?.dateTimeZone ? formats.dateTimeZone(contractData.startDate, 'dd/MM/yyyy') : contractData.startDate}</p>
                <p><strong>Número do Contrato:</strong> {contractData.controlContractNumber || 'Não disponível'}</p>
              </>
            )}
            <br />
            <h3 style={{ color: 'white', backgroundColor: '#4180aa', padding: '5px', borderRadius: 4, marginTop: 0 }}>Cadastro de IP ou DDNS</h3>
            <form onSubmit={handleAddIp} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: 12, width: '100%' }}>
              <input
                type="text"
                value={input}
                onChange={e => setInput(e.target.value)}
                placeholder="Digite um ou mais IPs/DDNS"
                style={{ width: '100%', minWidth: 180, marginBottom: 8 }}
                autoFocus
              />
              <Button type="submit" primary minWidth="80px">Adicionar</Button>
            </form>
            <div style={{ width: '100%', marginBottom: 8 }}>
              <label htmlFor="ticket-input" style={{ fontWeight: 500, display: 'block', marginBottom: 4 }}>Nº do Ticket <span style={{ color: 'red' }}>*</span></label>
              <input
                id="ticket-input"
                type="text"
                value={ticket}
                onChange={e => setTicket(e.target.value)}
                placeholder="Digite o número do Ticket"
                style={{ width: '100%', minWidth: 180, marginBottom: 4 }}
              />
            </div>
            <div style={{ width: '100%', marginBottom: 8 }}>
              <label htmlFor="obs-input" style={{ fontWeight: 500, display: 'block', marginBottom: 4 }}>Observação (opcional)</label>
              <input
                id="obs-input"
                type="text"
                value={observacao}
                onChange={e => setObservacao(e.target.value)}
                placeholder="Digite uma observação"
                style={{ width: '100%', minWidth: 180, marginBottom: 4 }}
              />
            </div>
            {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
          </div>
          <div style={{ flex: '1 1 0', minWidth: 490, maxWidth: 610, display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ border: '1px solid #eee', borderRadius: 4, padding: 12, background: '#fafbfc' }}>
              <strong style={{ color: '#477b4b', display: 'block', marginBottom: 4 }}>
                DDNS cadastrados:
                <span style={{ color: '#333', fontWeight: 400, fontSize: 13, marginLeft: 8 }}>
                  ({ips.filter(ip => /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(ip)).length})
                </span>
              </strong>
              <div style={{ maxHeight: 180, overflowY: 'auto' }}>
                <ul style={{ margin: '0', padding: 0, listStyle: 'none' }}>
                  {ips.filter(ip => /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(ip)).length === 0 && <li style={{ color: '#888' }}>Nenhum DDNS cadastrado</li>}
                  {ips.filter(ip => /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(ip)).map(ip => (
                    <li key={ip} style={{ display: 'flex', alignItems: 'center', marginBottom: 4, borderBottom: '1px solid #eee', padding: '2px 0' }}>
                      <IconButton size={28} type="button" title="Remover" onClick={() => handleRemoveIp(ip)} error style={{ margin: '0 8px 0 0' }}>
                        <MdDelete size={18} />
                      </IconButton>
                      <span style={{ flex: 1, wordBreak: 'break-all' }}>{ip}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div style={{ border: '1px solid #eee', borderRadius: 4, padding: 12, background: '#fafbfc' }}>
              <strong style={{ color: '#4180aa', display: 'block', marginBottom: 4 }}>
                IPs cadastrados:
                <span style={{ color: '#333', fontWeight: 400, fontSize: 13, marginLeft: 8 }}>
                  ({ips.filter(ip => !/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(ip)).length})
                </span>
              </strong>
              <div style={{ maxHeight: 180, overflowY: 'auto' }}>
                <ul style={{ margin: '0', padding: 0, listStyle: 'none' }}>
                  {ips.filter(ip => !/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(ip)).length === 0 && <li style={{ color: '#888' }}>Nenhum IP cadastrado</li>}
                  {ips.filter(ip => !/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(ip)).map(ip => (
                    <li key={ip} style={{ display: 'flex', alignItems: 'center', marginBottom: 4, borderBottom: '1px solid #eee', padding: '2px 0' }}>
                      <IconButton size={28} type="button" title="Remover" onClick={() => handleRemoveIp(ip)} error style={{ margin: '0 8px 0 0' }}>
                        <MdDelete size={18} />
                      </IconButton>
                      <span style={{ flex: 1, wordBreak: 'break-all' }}>{ip}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 32, display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <div style={{ display: 'flex', gap: 12, width: '590px', justifyContent: 'flex-end' }}>
            <Button onClick={handleSave} primary minWidth="140px" disabled={loading}>{loading ? 'Salvando...' : 'Salvar'}</Button>
            <Button onClick={onClose} minWidth="140px" style={{ marginLeft: 8 }}>Cancelar</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalIpList;
